import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ONBOARDING_V2 } from './onboarding/onboardingV2Routes';
import { debeIrAlCuestionario } from '../lib/cuestionarioObligatorio';

/**
 * Manda al cuestionario, en cada cambio de ruta, a quien lo tiene pendiente.
 *
 * Es la mitad que le faltaba al rebote de `App`: ése corre en eventos de sesión y no ve
 * una navegación SPA, así que cualquier salida de la cadena post-pago que cayera en la
 * app dejaba adentro, sin cuestionario, a quien acababa de pagar por el alta por link.
 * Va montado junto a `ScrollToTop`, que es el otro componente que mira cada ruta.
 * Ver ADR-2026-09-23-el-cuestionario-es-obligatorio-tambien-al-navegar.
 *
 * No consulta nada: el flag lo prende `checkUserProfile` con una lectura positiva del
 * centinela y lo apaga el cuestionario al escribir el rubro. Las rutas exentas son las
 * mismas del rebote (`rutaExentaDelCuestionario`), incluido el cuestionario mismo.
 */
export const GuardiaDelCuestionario = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (debeIrAlCuestionario(pathname)) navigate(ONBOARDING_V2.setup, { replace: true });
  }, [pathname, navigate]);

  return null;
};
